// extracted by mini-css-extract-plugin
export default {"loader":"athlete-favorite-star_loader__5eU8e"};